var _ellipse, _ellipse2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinoffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 18.5,
    rx: 8,
    ry: 3.5,
    fill: "#f44336"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 18.5,
    rx: 4,
    ry: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4131 11.7115V17.9171C11.4131 18.239 11.6757 18.5 11.9997 18.5C12.3236 18.5 12.5862 18.239 12.5862 17.9171V11.7115C15.1618 11.4031 17.0501 9.15463 16.8947 6.58125C16.7392 4.00787 14.5938 2 11.9997 2C9.40546 2 7.26008 4.00787 7.10465 6.58125C6.94921 9.15463 8.83751 11.4031 11.4131 11.7115ZM10.1143 7.73208C10.4383 7.73208 10.7009 7.4711 10.7009 7.14916C10.7009 6.25631 11.4292 5.53252 12.3277 5.53252C12.6516 5.53252 12.9143 5.27154 12.9143 4.9496C12.9143 4.62766 12.6516 4.36668 12.3277 4.36668C11.583 4.36873 10.8697 4.66468 10.3446 5.18942C9.81949 5.71415 9.52566 6.42468 9.52774 7.1647C9.5298 7.31725 9.59276 7.46273 9.70277 7.56914C9.81278 7.67554 9.96082 7.73416 10.1143 7.73208Z",
    fill: "#f44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinoffline);
export default __webpack_public_path__ + "static/media/LocationPinoffline.e72d70ebde54fd2d272b611c128b7e0e.svg";
export { ForwardRef as ReactComponent };